export default __webpack_public_path__ + "static/media/choose.c7b55fe3.jpg";